import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'tl',
    fullName: 'Filipino',
    nativeName: 'Filipino',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Something Amazing is Coming",
    landing_subtitle: "Ang ArgVoid ay isang app at game development studio. Manatiling nakatutok, ang mga bagong bagay ay paparating na!",
    select_language: "Piliin ang Wika",
    search_placeholder: "Maghanap ng mga wika...",
    terms_title: "Mga Tuntunin ng Serbisyo",
    policy_title: "Patakaran sa Privacy",
    cookies_title: "Patakaran sa Cookie",
    terms_content: `
        <strong>1. Pagtanggap ng Mga Tuntunin</strong><br>
        Sa pamamagitan ng pag-access sa ArgVoid, tinatanggap ang Mga Tuntunin ng Serbisyong ito. Kung hindi napagkasunduan ang mga tuntuning ito, hindi dapat gamitin ang serbisyo.<br><br>

        <strong>2. Paggamit ng Platform</strong><br>
        Ang ArgVoid at ang mga application nito ay ibinigay "as is" para sa mga layuning pang-impormasyon at malikhaing. Ang serbisyo ay dapat gamitin lamang para sa mga layuning ayon sa batas.<br><br>

        <strong>3. Ipinagbabawal na Pag-uugali</strong><br>
        Ang pagsasamantala sa mga kahinaan sa site, pag-spam, o pagtatangka ng hindi awtorisadong pag-access sa imprastraktura ay mahigpit na ipinagbabawal.<br><br>

        <strong>4. Disclaimer</strong><br>
        Ang platform at mga serbisyo ay maaaring mabago anumang oras nang walang abiso. Walang ibinigay na warranty tungkol sa uptime o availability ng serbisyo.
    `,
    policy_content: `
        <strong>1. Koleksyon ng Impormasyon</strong><br>
        Ang platform ay hindi nangangailangan ng pagpapatunay ng user o paggawa ng account sa ngayon. Walang personal na impormasyon sa pagkakakilanlan (tulad ng mga pangalan o email address) ang aktibong kinokolekta mula sa mga bisita.<br><br>

        <strong>2. Data ng Paggamit</strong><br>
        Maaaring kolektahin ang basic, anonymized na analytics upang maunawaan ang trapiko ng site at mapahusay ang mga application. Ang data na ito ay hindi naka-link sa mga indibidwal na pagkakakilanlan ng user.<br><br>

        <strong>3. Mga Serbisyo ng Third-Party</strong><br>
        Maaaring gamitin ang mga third-party na provider para sa mga serbisyo sa pagho-host at analytics. Ang mga kasanayan sa privacy ng kani-kanilang provider na ito ay namamahala sa anonymous na data na naproseso sa kanilang imprastraktura.<br><br>

        <strong>4. Seguridad ng Data</strong><br>
        Ang mga makatwirang hakbang sa seguridad ay ipinatupad upang protektahan ang platform. Gayunpaman, walang paraan ng paghahatid sa Internet ang ganap na ligtas.<br><br>
    `,
    cookies_content: `
        <strong>1. Ano ang Cookies at Lokal na Imbakan?</strong><br>
        Ang cookies at lokal na storage ng browser ay maliliit na file ng data na nakaimbak sa device upang matandaan ang mga kagustuhan sa configuration sa mga pagbisita.<br><br>

        <strong>2. Layunin ng Paggamit</strong><br>
        Ang Browser LocalStorage ay mahigpit na ginagamit upang i-save ang mga setting ng configuration, tulad ng:<br>
        - Mga kagustuhan sa wika<br>
        - Configuration ng user interface (hal., layout o mga setting ng tema)<br>
        - Pansamantalang application cache<br><br>

        <strong>3. Walang Pagsubaybay</strong><br>
        Ang cookies at lokal na imbakan ay hindi ginagamit para sa pag-advertise o mga layunin ng pagsubaybay ng third-party. Ang lahat ng nakaimbak na data ay mahigpit na para sa pangunahing pagpapagana ng platform.<br><br>

        <strong>4. Control</strong><br>
        Maaaring i-clear ang data ng browser anumang oras sa pamamagitan ng mga setting ng browser, na magre-reset ng anumang lokal na configuration.
    `,
    cookie_consent_text: "Gumagamit kami ng mga pangunahing cookies upang matiyak na gumagana nang tama ang website, tulad ng pagpapanatiling aktibo sa iyong session, pag-save ng iyong kagustuhan sa wika, at iba pang mga custom na configuration.",
    read_policy: "Basahin ang Patakaran sa Cookie",
    support_title: "Makipag-ugnayan sa Suporta",
    support_subject_label: "Paksa",
    support_message_label: "Mensahe",
    support_submit_button: "Magpadala ng Mensahe",
    support_hint: "Tandaan: Bubuksan nito ang iyong default na email application para ipadala ang mensahe.",
    support_success_msg: "Binubuksan ang iyong email app...",
    support_error_msg: "Nabigong magpadala ng mensahe. Pakisubukang muli mamaya.",
    explorer_title: "Explorer",
    history_title: "Kasaysayan",
    animation_title: "Animasyon",
    config_title: "Configuration",
    tool_mouse: "Piliin ang (Ctrl+M)",
    tool_brush: "Brush (Ctrl+B)",
    tool_brush_mode: "Toggle Mode (Solid/Clear)",
    tool_eraser: "Pambura (Ctrl+E)",
    tool_brush_size: "Ayusin ang Laki ng Brush",
    tool_bucket: "Punan (Ctrl+F)",
    tool_eyedropper: "Eyedropper",
    tool_grid: "Grid (Ctrl+Shift+B)",
    tool_rotate: "I-rotate (Ctrl+Shift+R)",
    tool_flip_h: "I-flip H (Ctrl+Shift+H)",
    tool_flip_v: "I-flip V (Ctrl+Shift+V)",
    tool_transpose: "Transpose (Ctrl+Shift+T)",
    label_width: "Lapad",
    label_height: "taas",
    label_frames: "Bilang ng mga Frame",
    label_animation: "Estilo ng Animasyon",
    label_background_color: "Kulay ng Background",
    label_interval: "Pagitan",
    tool_anim_config: "Configuration ng Animation",
    label_new_width: "Bagong Lapad",
    label_new_height: "Bagong Taas",
    label_apply: "Mag-apply",
    label_colors: "Mga kulay",
    label_size: "Sukat",
    label_tolerance: "Pagpaparaya",
    val_horizontal: "Pahalang",
    val_vertical: "Patayo",
    val_sequence: "Pagkakasunod-sunod",
    val_bounce: "Tumalbog",
    val_random: "Random",
    val_solid: "Solid",
    val_clear: "Maaliwalas",
    action_add_sheet: "Bagong Sheet",
    action_import: "Mag-import",
    action_export: "I-export",
    action_sort_projects: "Pagbukud-bukurin",
    sort_date_old: "Pinakamatanda Una",
    sort_date_new: "Pinakabago Una",
    sort_name_az: "Pangalan (A-Z)",
    sort_name_za: "Pangalan (Z-A)",
    action_new_sprite: "Bagong Sprite",
    action_new_project: "Bagong Proyekto",
    modal_save_all_title: "I-save ang Lahat ng Pagbabago",
    modal_save_all_desc: "Piliin ang mga asset na ise-save:",
    modal_save_selected: "I-save ang Napili",
    action_saved: "Nai-save",
    modal_create_sprite_title: "Lumikha ng Bagong Sprite",
    modal_create_project_title: "Lumikha ng Bagong Proyekto",
    modal_add_sheet_title: "Magdagdag ng Bagong Sheet",
    modal_rename_sheet_title: "Palitan ang pangalan ng Sheet",
    modal_rename_sprite_title: "Palitan ang pangalan ng Sprite",
    modal_delete_sprite_title: "Tanggalin ang Sprite",
    modal_delete_project_title: "Tanggalin ang Proyekto",
    modal_delete_sheet_title: "Tanggalin ang Sheet",
    placeholder_sprite_name: "Pangalan",
    placeholder_project_name: "Pangalan",
    placeholder_sheet_name: "Pangalan",
    placeholder_new_name: "Bagong Pangalan",
    action_create: "Lumikha",
    action_add: "Idagdag",
    action_rename: "Palitan ang pangalan",
    action_duplicate: "Duplicate",
    action_delete: "Tanggalin",
    action_cancel: "Kanselahin",
    confirm_delete_sprite: "Sigurado ka bang gusto mong tanggalin ang sprite na ito?",
    confirm_delete_project: "Sigurado ka bang gusto mong tanggalin ang proyektong ito? Ang lahat ng mga sprite ay aalisin.",
    confirm_delete_sheet: "Sigurado ka bang gusto mong tanggalin ang sheet na ito?",
    err_select_sprite: "Mangyaring pumili muna ng isang sprite.",
    err_select_project: "Mangyaring pumili muna ng proyekto.",
    err_name_empty: "Hindi maaaring walang laman ang pangalan.",
    err_sprite_exists: "Umiiral na ang isang sprite na may ganoong pangalan.",
    err_project_exists: "Umiiral na ang isang proyekto na may ganoong pangalan.",
    err_no_content: "Walang content na ise-save.",
    err_no_changes: "Walang mga pagbabagong ise-save.",
    err_delete_last_sheet: "Hindi matanggal ang huling sheet.",
    err_extract_frames: "Hindi ma-extract ang anumang mga frame.",
    err_indexeddb: "Nabigong i-save nang lokal. Maaaring hindi sinusuportahan ng iyong browser ang IndexedDB.",
    msg_upload_success: "Matagumpay na Pag-upload: {0}",
    msg_upload_failed: "Nabigo ang pag-upload: {0}",
    msg_save_success: "Matagumpay ang pag-save.",
    msg_saving: "Nagse-save...",
    msg_multi_save_result: "Nai-save ang {0} (na) asset. {1} mga pagkabigo.",
    menu_title: "Menu",
    menu_save: "I-save",
    menu_save_all: "I-save ang Lahat",
    menu_support: "Makipag-ugnayan sa Suporta",
    label_local_storage: "Lokal na Imbakan",
    label_sign_in: "Mag-sign In",
    modal_export_title: "I-export ang Sprite",
    label_filename: "Filename",
    label_format: "Format",
    action_export_confirm: "I-export",
};

export default translations;
